var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f4e340ba6ef56a4e2fdccbc489ce272d1f78c491"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["central-web@seac"]={id:"f4e340ba6ef56a4e2fdccbc489ce272d1f78c491"};
      